module.exports = __webpack_public_path__ + "static/img/application6-3.2d63be7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application6-3.jpg
// module id = pFY8
// module chunks = 0